import { getController as getBuildManagerController } from './serviceList/buildManager';
import { getController as getDMController } from './serviceList/dm';
import { getController as getFlowManagerController } from './serviceList/flowManager';
import { getController as getHrController } from './serviceList/hr';
import { getController as getIntegrationManagerController } from './serviceList/integrationManager';
import { getController as getLoginController } from './serviceList/login';
import { getController as getMainController } from './serviceList/main';
import { getController as getSolutionExplorerController } from './serviceList/solutionExplorer';
import { getController as getStudioController } from './serviceList/studio';
import { getController as getWebController } from './serviceList/web';
import { getController as getWebDavController } from './serviceList/webdav';
import { getController as getWorkflowController } from './serviceList/workflow';

export const ServiceList = {
	login: getLoginController('login'),
	IntegrationManager: getIntegrationManagerController('IntegrationManager'),
	dm: getDMController('dm'),
	webdav: getWebDavController('webdav'),
	workflow: getWorkflowController('workflow'),
	hr: getHrController('hr'),
	main: getMainController('main'),
	BuildManager: getBuildManagerController('BuildManager'),
	SolutionExplorer: getSolutionExplorerController('SolutionExplorer'),
	Studio: getStudioController('Studio'),
	FlowManager: getFlowManagerController('FlowManager'),
	web: getWebController('web')
};
